/* DSD notification bell route entry. Unread count is supplied by LaunchSocialActivation. */
(function(){
  'use strict';
  var VERSION = 'p11dz397-notification-bell-active-entry';

  function claim(surface, meta){
    try {
      var r = window.DSDRegistry || window.DSDRuntimeRegistry;
      if (r && typeof r.claim === 'function') r.claim(surface, 'NotificationBell', meta || {});
    } catch(e) {}
  }

  document.querySelectorAll('[data-dsd-notification-bell], .dsd-notification-bell-p11dz322').forEach(function(bell){
    bell.setAttribute('data-dsd-owner', 'LaunchSocialActivation');
    bell.setAttribute('data-dsd-notification-bell', 'p11dz397');
  });

  window.DSDNotificationBell322 = {
    version: VERSION,
    status: 'ACTIVE_ROUTE_ENTRY_COUNT_OWNED_BY_LAUNCH_SOCIAL',
    owner: 'LaunchSocialActivation',
    route: '/pages/notifications',
    countSource: 'canonical-supabase-notifications'
  };

  claim('notification-bell:header-entry', {
    version: VERSION,
    route: '/pages/notifications',
    singleOwner: true,
    countSource: 'LaunchSocialActivation'
  });
})();
